export enum SortType {
    NONE = 0,
    ASC = 1,
    DESC = 2,
    INACTIVE = 3,
}

function sortTypeString(sortType: SortType) {
    switch (sortType) {
        case 0:
            return '';
        case 1:
            return ',asc';
        case 2:
            return ',desc';
    }
}

export function sortValue(sortData: string, sortType: SortType): string | undefined {
    if (sortType === SortType.NONE || sortType === SortType.INACTIVE) return undefined;
    return `${sortData}${sortTypeString(sortType)}`;
}

export function nextStatus(sortStatus: SortType): SortType {
    switch (sortStatus) {
        case SortType.NONE:
            return SortType.ASC;
        case SortType.ASC:
            return SortType.DESC;
        case SortType.DESC:
            return SortType.NONE;
        default:
            return sortStatus;
    }
}
